export default __webpack_public_path__ + "static/pcc-logo-white-12f338829ea7cb2c6adb0d9798040740.svg";